import React, { useCallback, useContext, useMemo, useState } from 'react';
import InputConfirmationModal from '../InputConfirmationModal';
import useConfirmationProps from './useConfirmationProps';
import AccountContext from '../../../contexts/AccountContext';

const useCarrierNameConfirmation = ({ title }: { title: string }) => {
  const { carrierName } = useContext(AccountContext);
  const [body, setBody] = useState<string>('');
  const { getConfirmation, onConfirmed, onCancelled, isOpen } =
    useConfirmationProps();

  const CarrierNameConfirmation = useMemo(
    () => (
      <InputConfirmationModal
        requiredInput={carrierName}
        isOpen={isOpen}
        close={onCancelled}
        title={title}
        body={body}
        onConfirmed={onConfirmed}
        buttonTestId={'confirm-carrier-name'}
        inputTestId={'carrier-name-input'}
      />
    ),
    [body, carrierName, isOpen, onCancelled, onConfirmed, title],
  );

  const getConfirmationThat = useCallback(
    (confirmationBody: string) => {
      setBody(confirmationBody);
      return getConfirmation();
    },
    [getConfirmation],
  );

  return { getConfirmationThat, CarrierNameConfirmation };
};

export default useCarrierNameConfirmation;
